import * as React from 'react';

import Form from './Form';
import HistoryRowData from './HistoryRowData';

import DocumentHeader from 'Components/DocumentHeader';
import DocumentWrapper from 'Components/DocumentWrapper';
import HistoryRow from 'Components/HistoryRow';
import FormEditingHandler from 'Containers/FormEditingHandler';
import { formatPartialDate } from 'Utility/date';
import { sortPartialDate } from 'neuro-utils';
import HistoryRowControls from 'Components/HistoryRowControls';
import DocumentCreationButton from 'Components/DocumentCreationButton';

const NeurologicalStatusAndEDSS = ({ documents }: IOwnProps): React.JSX.Element => {
  return (
    <FormEditingHandler name="neurologicalStatusAndEDSS" documents={documents}>
      {(editing, startEdit, formData, view): React.JSX.Element => (
        <DocumentWrapper>
          <DocumentHeader
            name="neurologicalStatusAndEDSS"
            headerId={'neurologicalStatusAndEDSS.title'}
            editing={editing}
            editButtons={
              view?.viewing ? (
                <div />
              ) : (
                <div>
                  <DocumentCreationButton
                    name="neurologicalStatusAndEDSS"
                    text={'general.new'}
                    onClick={startEdit({})}
                  />
                </div>
              )
            }
          />

          {editing ? <Form documents={documents} formData={formData} /> : null}

          {view?.viewing ? (
            <Form
              documents={documents}
              formData={{ document: view.document, onChange: (): string => '' }}
              viewing={!!view.viewing}
            />
          ) : null}

          {!editing && !view?.viewing
            ? documents
                .toSorted((n1, n2) => sortPartialDate(n2.date, n1.date) || n2._cdate - n1._cdate)
                .map(d => (
                  <HistoryRow
                    headerText={d.date ? formatPartialDate(d.date) : undefined}
                    key={d._id}
                    rowButton={<HistoryRowControls document={d} startEdit={startEdit} view={view} />}
                    controlsMargin={false}
                  >
                    <HistoryRowData d={d} />
                  </HistoryRow>
                ))
            : undefined}
        </DocumentWrapper>
      )}
    </FormEditingHandler>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'neurologicalStatusAndEDSS'>[];
}

export default NeurologicalStatusAndEDSS;
